// Polyfills for MQTT.js
import { Buffer } from 'buffer';
import process from 'process';
import { EventEmitter } from 'events';

(window as any).Buffer = Buffer;
(window as any).process = process;
(window as any).global = globalThis;

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import router from '@/router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// 重新启用全局样式引入
import '@/styles/tailwind.css';
import '@/styles/index.scss';
//
// 国际化配置
import { i18n } from '@/locales';
// 全局组件
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
// WebSocket服务已暂时移除

// 引导标记，便于在浏览器检测执行进度
;(window as any).__bootStart = true;

// 创建Vue应用
const app = createApp(App);
;(window as any).__appCreated = true;
// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// 使用插件
app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.use(i18n);
// WebSocket插件已暂时移除

// 挂载应用
app.mount('#app');
;(window as any).__appMounted = true;

// 应用加载完成后移除加载动画
const loadingContainer =
document.querySelector('.loading-container');

if (loadingContainer) {
  loadingContainer.remove();
}

document.body.classList.add('v-app-loaded');

// 全局错误处理
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err, instance, info);
  // 可以在这里集成错误上报服务
};

// 全局性能监控
declare global {
  interface ImportMeta {
    env: {
      DEV: boolean;
      VITE_APP_VERSION?: string;
    };
  }
}

if (import.meta.env.DEV) {
  console.log(
    `%cVisuduo SaaS Platform %cv${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
    'color: #409EFF; font-size: 20px; font-weight: bold;',
    'color: #67C23A; font-size: 14px;'
  );
}
